import { render, staticRenderFns } from "./ecPreisStaffel.vue?vue&type=template&id=b1209698&lang=pug"
import script from "./ecPreisStaffel.vue?vue&type=script&lang=ts"
export * from "./ecPreisStaffel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCard: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VCard/VCard.js').default,VTimelineItem: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VTimeline/VTimelineItem.js').default,VTimeline: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VTimeline/VTimeline.js').default})
